(function () {
  function initGalleryProgress() {
    document.querySelectorAll('main#MainContent section.main-product--section.klaim-pdp-v2 > .klaim-pdp-flaneur [data-klaim-gallery]').forEach(function (gallery) {
      if (gallery.dataset.klaimGalleryProgressReady === 'true') return;

      var track = gallery.querySelector('.product-media--mobile-slider--desktop-slider');
      var slides = track ? Array.from(track.querySelectorAll(':scope > .product-media-image')) : [];
      var progress = gallery.querySelector('[data-klaim-gallery-progress]');
      var thumbnails = Array.from(gallery.querySelectorAll('.gallery-slider--thumbnail'));

      if (!track || slides.length === 0 || !progress) return;

      gallery.dataset.klaimGalleryProgressReady = 'true';
      progress.setAttribute('aria-valuemax', String(slides.length));

      var measureFrame = 0;
      var motionFrame = 0;
      var targetScale = 0;
      var renderedScale = 0;
      var velocity = 0;
      var previousTime = 0;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var isDesktopStack = function () {
        // Desktop PDP media is rendered as a vertical page stack even when
        // the theme's track class still reports the slider layout.
        return window.matchMedia('(min-width: 950px)').matches;
      };

      var clamp = function (value, minimum, maximum) {
        return Math.max(minimum, Math.min(maximum, value));
      };

      var positionDesktopProof = function () {
        var proof = gallery.querySelector(':scope > .klaim-pdp-flaneur__buyer-proof--gallery');
        if (!proof) return;

        if (!isDesktopStack()) {
          proof.classList.remove('klaim-pdp-flaneur__buyer-proof--released');
          proof.style.removeProperty('--klaim-buyer-proof-release-top');
          delete proof.dataset.klaimBuyerProofStickyTop;
          return;
        }

        var media = gallery.querySelector(':scope > .product-media-component');
        if (proof && media && proof.nextElementSibling !== media) gallery.insertBefore(proof, media);

        var lastSlide = slides[slides.length - 1];
        if (!lastSlide) return;

        if (!proof.classList.contains('klaim-pdp-flaneur__buyer-proof--released')) {
          var computedStickyTop = parseFloat(window.getComputedStyle(proof).top);
          if (Number.isFinite(computedStickyTop)) {
            proof.dataset.klaimBuyerProofStickyTop = String(computedStickyTop);
          }
        }

        var stickyTop = parseFloat(proof.dataset.klaimBuyerProofStickyTop);
        if (!Number.isFinite(stickyTop)) stickyTop = 92;

        var proofHeight = proof.getBoundingClientRect().height;
        var galleryRect = gallery.getBoundingClientRect();
        var lastSlideRect = lastSlide.getBoundingClientRect();
        var shouldRelease = lastSlideRect.top <= stickyTop + proofHeight;

        proof.classList.toggle('klaim-pdp-flaneur__buyer-proof--released', shouldRelease);
        if (shouldRelease) {
          galleryRect = gallery.getBoundingClientRect();
          lastSlideRect = lastSlide.getBoundingClientRect();
          proofHeight = proof.getBoundingClientRect().height;
        }

        var releaseTop = Math.max(0, lastSlideRect.top - galleryRect.top - proofHeight);
        proof.style.setProperty('--klaim-buyer-proof-release-top', releaseTop + 'px');
      };

      var getActiveIndex = function () {
        if (isDesktopStack()) {
          var viewportCenter = window.innerHeight / 2;
          var activeStackIndex = 0;
          var closestStackDistance = Infinity;

          slides.forEach(function (slide, slideIndex) {
            var rect = slide.getBoundingClientRect();
            var distance = Math.abs((rect.top + rect.height / 2) - viewportCenter);
            if (distance < closestStackDistance) {
              closestStackDistance = distance;
              activeStackIndex = slideIndex;
            }
          });

          return activeStackIndex;
        }

        var scrollPosition = track.scrollLeft;
        var viewportCenter = scrollPosition + (track.clientWidth / 2);
        var activeIndex = 0;
        var closestDistance = Infinity;

        slides.forEach(function (slide, slideIndex) {
          var slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
          var distance = Math.abs(slideCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = slideIndex;
          }
        });

        return activeIndex;
      };

      var getProgressScale = function () {
        if (slides.length <= 1) return 1;

        if (isDesktopStack()) {
          var firstRect = slides[0].getBoundingClientRect();
          var lastRect = slides[slides.length - 1].getBoundingClientRect();
          var firstCenter = firstRect.top + (firstRect.height / 2);
          var lastCenter = lastRect.top + (lastRect.height / 2);
          var travel = lastCenter - firstCenter;
          var viewportAnchor = window.innerHeight / 2;
          var stackProgress = travel > 0 ? (viewportAnchor - firstCenter) / travel : 1;
          return (1 + (clamp(stackProgress, 0, 1) * (slides.length - 1))) / slides.length;
        }

        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var horizontalProgress = maxScroll > 0 ? track.scrollLeft / maxScroll : 1;
        return (1 + (clamp(horizontalProgress, 0, 1) * (slides.length - 1))) / slides.length;
      };

      var renderProgress = function (scale) {
        var safeScale = clamp(scale, 0, 1);
        progress.style.setProperty('--klaim-gallery-progress', (safeScale * 100) + '%');
        progress.style.setProperty('--klaim-gallery-progress-scale', safeScale.toFixed(6));
      };

      var animateProgress = function (timestamp) {
        motionFrame = 0;
        if (!progress.isConnected) return;

        if (reducedMotion.matches) {
          renderedScale = targetScale;
          velocity = 0;
          previousTime = 0;
          renderProgress(renderedScale);
          return;
        }

        var deltaTime = previousTime ? Math.min((timestamp - previousTime) / 1000, 0.032) : (1 / 60);
        previousTime = timestamp;

        // Critically damped spring: smooth enough to remove stepped motion,
        // responsive enough to stay attached to the user's scroll position.
        var acceleration = ((targetScale - renderedScale) * 170) - (velocity * 26);
        velocity += acceleration * deltaTime;
        renderedScale += velocity * deltaTime;

        if (Math.abs(targetScale - renderedScale) < 0.0001 && Math.abs(velocity) < 0.0001) {
          renderedScale = targetScale;
          velocity = 0;
          previousTime = 0;
          renderProgress(renderedScale);
          return;
        }

        renderProgress(renderedScale);
        motionFrame = window.requestAnimationFrame(animateProgress);
      };

      var setProgressTarget = function (scale, immediate) {
        targetScale = clamp(scale, 0, 1);
        if (immediate || reducedMotion.matches) {
          if (motionFrame) window.cancelAnimationFrame(motionFrame);
          motionFrame = 0;
          renderedScale = targetScale;
          velocity = 0;
          previousTime = 0;
          renderProgress(renderedScale);
          return;
        }
        if (!motionFrame) motionFrame = window.requestAnimationFrame(animateProgress);
      };

      var update = function (immediate) {
        positionDesktopProof();
        var index = getActiveIndex();
        index = Math.max(0, Math.min(slides.length - 1, index));
        setProgressTarget(getProgressScale(), immediate === true);
        progress.setAttribute('aria-valuenow', String(index + 1));

        thumbnails.forEach(function (thumbnail, thumbnailIndex) {
          var active = thumbnailIndex === index;
          thumbnail.classList.toggle('active', active);
          if (active) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
      };

      var measureProgress = function () {
        measureFrame = 0;
        update(false);
      };

      var scheduleUpdate = function () {
        if (measureFrame) return;
        measureFrame = window.requestAnimationFrame(measureProgress);
      };

      track.addEventListener('scroll', scheduleUpdate, { passive: true });
      track.addEventListener('pointerup', scheduleUpdate, { passive: true });
      track.addEventListener('scrollend', scheduleUpdate, { passive: true });
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      reducedMotion.addEventListener?.('change', scheduleUpdate);

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function () {
          var thumbnailIndex = thumbnails.indexOf(thumbnail);
          var targetSlide = slides[thumbnailIndex];
          if (targetSlide) {
            if (isDesktopStack()) targetSlide.scrollIntoView({ behavior: 'smooth', block: 'start' });
            else track.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
          }
          window.setTimeout(scheduleUpdate, 0);
          window.setTimeout(scheduleUpdate, 220);
          window.setTimeout(scheduleUpdate, 640);
        });
      });

      if (window.ResizeObserver) {
        new ResizeObserver(scheduleUpdate).observe(track);
      }

      update(true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryProgress, { once: true });
  } else {
    initGalleryProgress();
  }

  document.addEventListener('shopify:section:load', initGalleryProgress);
})();
